import React from 'react';
import { TextFieldProps } from '@mui/material/TextField';
import { Icon, InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { LockOutlined } from '@mui/icons-material';
import LoginFormField from '@/components/common/LoginFormField';

const PasswordField: React.FC<Omit<TextFieldProps, 'type' | 'InputProps'>> = (
    props,
) => {
    const [show, setShow] = React.useState<boolean>(false);

    const toggleVisibility = () => {
        setShow(!show);
    };

    return (
        <LoginFormField
            type="password"
            InputProps={{
                type: !show ? 'password' : 'text',
                startAdornment: (
                    <InputAdornment position="start">
                        <LockOutlined sx={{ color: '#8690A4' }} />
                    </InputAdornment>
                ),
                endAdornment: props.value ? (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={toggleVisibility}>
                            {show && (
                                <Icon sx={{ color: '#8690A4' }}>
                                    visibility_off
                                </Icon>
                            )}
                            {!show && (
                                <Icon sx={{ color: '#8690A4' }}>
                                    visibility
                                </Icon>
                            )}
                        </IconButton>
                    </InputAdornment>
                ) : <></>,
                autoComplete: 'off',
            }}
            {...props}
        ></LoginFormField>
    );
};

export default PasswordField;
